export enum CommonPageDetailsTranslation {
  Active = 'generic.status.active',
  Inactive = 'generic.status.inactive',
  deactivateUserConfirm = 'modules.siteadmin.deactivateUserConfirm',
  reactivateUserConfirm = 'modules.siteadmin.reactivateUserConfirm'
}
